export enum CreditsType {
  FREE = 'FREE',
  MONTHLY = 'MONTHLY',
  ADDON = 'ADDON',
  EVENT = 'EVENT',
  DAILY = 'DAILY',
  LIABILTY = 'LIABILTY',
}
export const CreditsMap = {
  FREE: 'free',
  MONTHLY: 'monthly',
  ADDON: 'addon',
  EVENT: 'event',
  DAILY: 'daily',
  LIABILTY: 'liability',
};
